import { ApplicationErrorBoundary } from './ErrorBoundary';

export default ApplicationErrorBoundary;
